<app-breadcrumb [home]="home" [items]="breadcrumbs" />

<header class="page-header">
  <span class="client-deals__eyebrow">Sua operação com a Legatus</span>
  <h2>Minha operação</h2>
</header>

@if (loading()) {
  <div class="client-loading" role="status" aria-label="Carregando">
    <app-cog-loading-spinner [size]="64" />
  </div>
} @else if (errorMessage()) {
  <div class="client-deals__error" role="alert">
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
    <div>
      <strong>As suas operações não carregaram.</strong>
      <p>{{ errorMessage() }}</p>
    </div>
    <app-button
      label="Tentar de novo"
      icon="pi pi-refresh"
      theme="white"
      [type]="'button'"
      (sendButtonClick)="load()" />
  </div>
} @else if (isEmpty()) {
  <div class="client-deals__empty" role="note">
    <i class="pi pi-info-circle" aria-hidden="true"></i>
    <p>Ainda não há operação em andamento para a sua empresa.</p>
  </div>
}
